import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import subscriptionUpdaters from '@/api/updaters/content-studio/subscription';
import {CURRENT_SUBSCRIPTION, CONTENT_LAB} from '@/hooks/content-studio/consts';

function useContentStudioCancelSubscriptionMutation() {
  return useMutation({
    mutationFn: (paymentSourceId: string) =>
      subscriptionUpdaters.updateAutoRenewalStatus(paymentSourceId, false),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CONTENT_LAB, CURRENT_SUBSCRIPTION],
        exact: false,
      });
    },
  });
}

export default useContentStudioCancelSubscriptionMutation;
